import React from 'react';

export interface TeaserNeuroHeadlineProps {
  topContent?: string,
  mainContent: string,
  bottomContent?: string,
}

const TeaserNeuroHeadline: React.FC<TeaserNeuroHeadlineProps> = ({
  topContent,
  mainContent,
  bottomContent,
}) => (
  <h2 className="headline">
    {topContent && <span className="small" dangerouslySetInnerHTML={{ __html: topContent }} />}
    <br />
    <span className="lead" dangerouslySetInnerHTML={{ __html: mainContent }} />
    <br />
    {bottomContent && <span className="small" dangerouslySetInnerHTML={{ __html: bottomContent }} />}
  </h2>
);

export default TeaserNeuroHeadline;
